angular.module('property')
    .component('propertyWindowSideSelect', {
        bindings: {
            onChange: '&',
            required: "="
        },
        require: {
            ngModelCtrl: 'ngModel'
        },
        template: `
            <select id="windowSide" class="form-control" ng-model="$ctrl.selected" ng-options="('property.windowSide.' + u | translate) for u in $ctrl.items" ng-change="$ctrl.onSelectionChanged()">
                <option value="" translate="property.windowSide.select"></option>
            </select>
        `,
        controller: function (Property) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.items = Property.windowSides()

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => viewValue);
            };

            ctrl.onSelectionChanged = () => {
                ctrl.ngModelCtrl.$setViewValue(ctrl.selected);
                ctrl.ngModelCtrl.$validate();

                if (angular.isFunction(ctrl.onChange())) {
                    ctrl.onChange()(ctrl.selected);
                }
            };

        }
    })
